import { createContext } from 'react'

export const RemittanceContext = createContext()
